import VueRouter from 'vue-router';
import authCheck from '@middleware/auth-check';
import AuthService from '@services/auth.service';

import Wrapper from '@views/Wrapper';
import AuthWrapper from '@views/AuthWrapper';
import Landing from '@views/Landing';
import Prices from '@views/Prices';
import PriceList from '@views/Prices/views/PriceList';
import PriceType from '@views/Prices/views/PriceType';
import Renting from '@views/Renting';
import Booking from '@views/Booking';
import BookingSuccess from '@views/Booking/views/Success';
import Specials from '@views/Specials';
import SpecialsShow from '@views/Specials/Show';
import Contact from '@views/Contact';
import Vehicles from '@views/Vehicles';

import Login from '@views/Auth/Login';
import Register from '@views/Auth/Register';
import Email from '@views/Auth/Password/Email';
import Reset from '@views/Auth/Password/Reset';
import Resend from '@views/Auth/Verification/Resend';
import Verify from '@views/Auth/Verification/Verify';

import adminRoutes from '@views/Admin/routes';

let routes = [
    {
        path: '/',
        component: AuthWrapper,
        children: [
            { path: '', name: 'home', components: { unauthorized: Landing } },
            {
                path: 'hinnad',
                name: 'prices',
                components: { unauthorized: Prices },
                children: [
                    {
                        path: ':pl_slug',
                        name: 'prices.list',
                        components: { prices: PriceList },
                        children: [
                            {
                                path: 'autod',
                                name: 'prices.car',
                                components: { 'price-type': PriceType }
                            },
                            {
                                path: 'bussid',
                                name: 'prices.minibus',
                                components: { 'price-type': PriceType }
                            },
                            {
                                path: 'kaubikud',
                                name: 'prices.commercial.vehicle',
                                components: { 'price-type': PriceType }
                            },
                            {
                                path: 'lisavarustus',
                                name: 'prices.eqs',
                                components: { 'price-type': PriceType }
                            },
                            {
                                path: 'koik',
                                name: 'prices.all',
                                components: { 'price-type': PriceType }
                            }
                        ]
                    }
                ]
            },
            { path: 'vehicles', name: 'landing', components: { unauthorized: Vehicles } },
            { path: 'rentimine', name: 'renting', components: { unauthorized: Renting } },
            { path: 'broneerimine/:vehicle_slug', name: 'pub.booking', components: { unauthorized: Booking } },
            { path: 'broneering', name: 'pub.booking.success', components: { unauthorized: BookingSuccess } },
            { path: 'eripakkumised', name: 'specials', components: { unauthorized: Specials } },
            { path: 'eripakkumised/:special_slug', name: 'specials.show', components: { unauthorized: SpecialsShow } },
            { path: 'kontakt', name: 'contact', components: { unauthorized: Contact } }
        ]
    },
    {
        path: '/auth',
        redirect: '/auth/login',
        component: AuthWrapper,
        children: [
            { path: 'login', name: 'login', components: { unauthorized: Login } },
            // { path: 'register', name: 'register', components: { unauthorized: Register } },
            { path: 'password/reset', name: 'password.request', components: { unauthorized: Email } },
            { path: '/password/reset/:token', name: 'password.reset', components: { unauthorized: Reset } },
            { path: 'email/verify/:id', name: 'verification.verify', components: { unauthorized: Verify } },
            { path: 'email/resend', name: 'verification.resend', components: { unauthorized: Resend } }
        ]
    },
    {
        path: '/auth',
        redirect: 'dashboard',
        component: Wrapper,
        meta: {
            middleware: [authCheck]
        },
        children: [...adminRoutes]
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
    linkActiveClass: 'active',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            if (to.hash) {
                return { selector: to.hash };
            }
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    //      to.path === '/auth/register',

    if (to.path.includes('autod') || to.path.includes('bussid') || to.path.includes('kaubikud') || to.path.includes('lisavarustus') || to.path.includes('koik')) {
        localStorage.setItem('pricelist_route', to.name);
    }

    if (AuthService.isAuthorized) {
        next();
    } else {
        const accessConditions = [
            to.path === '/',
            to.path === '/rentimine',
            to.path === '/kontakt',
            to.path === '/broneering',
            to.path.startsWith('/hinnad'),
            to.path.startsWith('/broneerimine'),
            to.path.startsWith('/eripakkumised'),
            to.path === '/auth/login',
            to.path === '/auth/email/resend',
            to.path.startsWith('/password/reset'),
            to.path.startsWith('/auth/password/reset'),
            to.path.startsWith('/auth/email/verify')
        ];

        if (accessConditions.some(item => item)) {
            next();
        } else {
            if (from.path !== '/auth/login') {
                next({
                    path: '/'
                });
            }
        }
    }
});

export default router;
